import { useIsUngated } from 'ai-components-ui-library/hooks/useIsUngated';
import { useIsUngatedForCopilotV2 } from 'ai-components-ui-library/hooks/useIsUngatedForCopilotV2';
import { gate } from 'hub-http/gates';
export const useIsUngatedForCopilotPreviewActionOnV2 = () => {
  return useIsUngated(gate('CopilotPreviews:ActionsOnV2'));
};
export const useShouldShowActions = () => {
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  const isUngatedForCopilotPreviewActionOnV2 = useIsUngatedForCopilotPreviewActionOnV2();
  return !isUngatedForCopilotV2 || isUngatedForCopilotV2 && isUngatedForCopilotPreviewActionOnV2;
};